import { render, staticRenderFns } from "./FinancialRatio.vue?vue&type=template&id=beb34388&"
import script from "./FinancialRatio.vue?vue&type=script&lang=js&"
export * from "./FinancialRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports